
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/go/[usercode]",
      function () {
        return require("private-next-pages/go/[usercode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/go/[usercode]"])
      });
    }
  